import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { useTranslation } from "react-i18next";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function CurrentSalaryIsLiquid({
  searchObject,
  setSearchObject
}) {
  const { t } = useTranslation();

  function clearCurrentSalaryNetGross() {
    let _searchObject = { ...searchObject };
    _searchObject.currentSalaryValueIsLiquid = undefined;

    setSearchObject(_searchObject);
  }

  const onChangeCurrentSalaryType = (event) => {
    setSearchObject({
      ...searchObject,
      currentSalaryValueIsLiquid:
        event.target.id === "currentSalaryValueIsLiquid" ? true : false
    });
  };

  return (
    <div>
      <div className="form-check position-toogle-salary">
        <input
          className="form-check-input"
          type="radio"
          name="currentSalaryValueIsLiquid"
          id="currentSalaryValueIsLiquid"
          onChange={onChangeCurrentSalaryType}
          checked={searchObject.currentSalaryValueIsLiquid}
        />
        <label htmlFor="CurrentSalaryValueIsLiquid">{t("Liquid")}</label>
        <input
          className="form-check-input"
          type="radio"
          name="currentSalaryValueIsLiquid"
          id="currentSalaryValueIsNotLiquid"
          style={{ marginLeft: "30px" }}
          onChange={onChangeCurrentSalaryType}
          checked={searchObject.currentSalaryValueIsLiquid === false}
        />
        <label htmlFor="currentSalaryValueIsNotLiquid">{t("Gross")}</label>
      </div>
      {(searchObject.currentSalaryValueIsLiquid === true ||
        searchObject.currentSalaryValueIsLiquid === false) && (
        <button
          onClick={clearCurrentSalaryNetGross}
          className="btn-clear-salary-net-gross"
        >
          <img
            src={IconDelete}
            alt="ico-ppl"
            height="12px"
            width="auto"
            style={{ height: "14px" }}
          />
          <a className="clear-button">{t("Clear")}</a>
        </button>
      )}
    </div>
  );
}
